<template>
  <div>
    <img
      v-if="
        file.thumb !== undefined &&
          (file.type === 'jpeg' ||
            file.type === 'JPEG' ||
            file.type === 'jpg' ||
            file.type === 'JPG' ||
            file.type === 'image/jpeg')
      "
      :src="file.thumb"
      class="upload-attachment__loading__file--icon"
    />
    <img
      v-else-if="
        file.thumb === undefined &&
          (file.type === 'jpeg' ||
            file.type === 'JPEG' ||
            file.type === 'jpg' ||
            file.type === 'JPG' ||
            file.type === 'image/jpeg')
      "
      src="../../assets/images/icons/jpg.png"
    />
    <img
      v-else-if="
        file.thumb !== undefined &&
          (file.type === 'png' ||
            file.type === 'PNG' ||
            file.type === 'image/png')
      "
      :src="file.thumb"
      class="upload-attachment__loading__file--icon"
    />
    <img
      v-else-if="
        file.thumb === undefined &&
          (file.type === 'png' ||
            file.type === 'PNG' ||
            file.type === 'image/png')
      "
      src="../../assets/images/icons/png.svg"
    />
    <img
      v-else-if="
        file.type === 'pdf' ||
          file.type === 'PDF' ||
          file.type === 'application/pdf'
      "
      src="../../assets/images/icons/pdf.svg"
    />
    <img
      v-else-if="
        file.type === 'csv' ||
          file.type === 'CSV' ||
          file.type === 'text/csv'
      "
      src="../../assets/images/icons/csv.png"
    />
    <img
      v-else-if="
        file.type === 'xlsx' ||
          file.type === 'XLSX' ||
          file.type === 'xls' ||
          file.type === 'XLS' ||
          file.type === 'application/vnd.ms-excel' ||
          file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      "
      src="../../assets/images/icons/xls.svg"
    />
    <img v-else-if="isOutlookMessage(file)" src="../../assets/images/icons/outlook.png" />
  </div>
</template>

<script>
export default {
  name: "AttachmentItem",
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isOutlookMessage({ fileName }) {
      return fileName.split(".").pop() === `msg`;
    },
  },
};
</script>